import { render, staticRenderFns } from "./GoogleCalendarEditModal.vue?vue&type=template&id=2afc4aea"
import script from "./GoogleCalendarEditModal.vue?vue&type=script&lang=ts"
export * from "./GoogleCalendarEditModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2afc4aea')) {
      api.createRecord('2afc4aea', component.options)
    } else {
      api.reload('2afc4aea', component.options)
    }
    module.hot.accept("./GoogleCalendarEditModal.vue?vue&type=template&id=2afc4aea", function () {
      api.rerender('2afc4aea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/GoogleCalendarEditModal.vue"
export default component.exports